import alertBarTheme from 'components/AlertBar/AlertBar.theme';
import animatedAccordionTheme from 'components/AnimatedAccordion/AnimatedAccordion.theme';
import customAlertBarTheme from 'components/CustomAlertBar/CustomAlertBar.theme';
import drawerTheme from 'components/Drawer/Drawer.theme';
import floatingButtonTheme from 'components/FloatingButton/FloatingButton.theme';
import { FooterTheme } from 'components/Footer/Footer.theme';
import infoBanner from 'components/InfoBanner/InfoBanner.theme';
import modal from 'components/Modal/Modal.theme';
import radioInputTheme from 'components/RadioInput/RadioInput.theme';
import scrollableNavigationToolbarTheme from 'components/ScrollableNavigationToolbar/ScrollableNavigationToolbar.theme';
import selectTheme from 'components/Select/Select.theme';
import { stepperTheme } from 'components/Stepper/Stepper.theme';
import { tableTheme } from 'components/Table/Table.theme';
import trisTitle from 'components/TrisTitle/TrisTitle.theme';
import { APP_VENDOR } from 'config';
import { feedbackCardTheme } from 'pages/dashboard/partials/FeedbackCard/styles/FeedbackCard.theme';
import userDataEntryTheme from 'pages/profile/profile.helpers';
import breakpoints from 'style-utils/breakpoints';
import colors from 'style-utils/colors';
import checkbox from './components/Checkbox/Checkbox.theme';

const theme = {
  vendor: APP_VENDOR,
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  palette: {
    primary: colors.black,
    secondary: colors.gradientsOrangeLight,
    disabled: colors.grey,
  },
  zIndexes: {
    sidebarNavContent: 2,
    footerOverlay: 100,
    modal: {
      overlay: 101,
    },
    listbox: {
      button: 12,
      list: 11,
      // Set it higher than `listboxButton` if you want it rendered above
      // when expanded.
      listExpanded: 13,
    },
    drawer: {
      overlay: 500,
      slider: 501,
    },
  },
  infoBanner: {
    ...infoBanner,
  },
  ...customAlertBarTheme,
  ...modal,
  ...animatedAccordionTheme,
  ...alertBarTheme,
  ...trisTitle,
  ...selectTheme,
  ...checkbox,
  ...radioInputTheme,
  ...drawerTheme,
  ...floatingButtonTheme,
  ...scrollableNavigationToolbarTheme,
  ...userDataEntryTheme,
  ...stepperTheme,
  ...FooterTheme,
  ...tableTheme,
  ...feedbackCardTheme,
};

// Styled Boostrap Grid Theme.
// see: https://github.com/dragma/styled-bootstrap-grid#advanced
const grid = { breakpoints };

if (!import.meta.env.PROD) {
  Object.freeze(theme);
  Object.freeze(grid);
}

export type Theme = Readonly<typeof theme>;
export type Grid = Readonly<typeof grid>;

export { grid, theme };
